import type { ParteDistribuicao } from "@/modules/financeiro-configuracoes";

export const DISTRIBUICOES_TITULO = "Distribuições por coletor";
export const DISTRIBUICOES_DESCRICAO =
  "Define como o valor de Materiais e o de Serviços de um escopo macro são divididos entre os coletores de custo. Cada distribuição tem as duas partes, e cada parte soma 100%. É usada no Financeiro de cada obra, no modal Editar escopo macro.";

export const DISTRIBUICOES_NOVA_LABEL = "Nova distribuição";
export const DISTRIBUICOES_MOSTRAR_INATIVAS_LABEL = "Mostrar inativas";

export const DISTRIBUICOES_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar as distribuições.";
export const DISTRIBUICOES_ERROR_MESSAGE = "Não foi possível carregar as distribuições.";
export const DISTRIBUICOES_TENTAR_DE_NOVO = "Tentar de novo";
export const DISTRIBUICOES_LOADING_LABEL = "Carregando distribuições...";
export const DISTRIBUICOES_VAZIO_TITULO = "Nenhuma distribuição cadastrada";
export const DISTRIBUICOES_VAZIO_DESCRICAO =
  "As distribuições cadastradas aqui dividem os valores de Materiais e de Serviços entre os coletores.";

export const DISTRIBUICAO_CRIADA = "Distribuição criada com sucesso.";
export const DISTRIBUICAO_EDITADA = "Distribuição editada com sucesso.";
export const DISTRIBUICAO_INATIVADA = "Distribuição inativada com sucesso.";
export const DISTRIBUICAO_ATIVADA = "Distribuição ativada com sucesso.";

export const DISTRIBUICAO_TAG_INATIVA = "Inativa";
export const DISTRIBUICAO_TAG_FIXO = "Fixo";
export const DISTRIBUICAO_FACILIDADES_NOTA = "Sempre 100% no coletor K";

/** Valor de `alteradaPor` das distribuições que nunca foram editadas. */
export const DISTRIBUICAO_CARGA_INICIAL = "Carga inicial";

export const PARTE_ROTULOS: Record<ParteDistribuicao, string> = {
  MATERIAIS: "Materiais",
  SERVICOS: "Serviços",
  FACILIDADES: "Facilidades",
};
